const detail = {
  namespaced: true,
  state: {
    id: null,
    name: null,
    description: null,
    imageUrl: null,
    lat: null,
    lng: null,
    fromSns: false
  },
  getters: {
    getId: (state) => state.id,
    getName: (state) => state.name,
    getDescription: (state) => state.description,
    getImageUrl: (state) => state.imageUrl,
    getLat: (state) => state.lat,
    getLng: (state) => state.lng,
    getFromSns: (state) => state.fromSns
  },
  mutations: {
    setId (state, id) {
      state.id = id
    },
    setName (state, name) {
      state.name = name
    },
    setDescription (state, description) {
      state.description = description
    },
    setImageUrl (state, imageUrl) {
      state.imageUrl = imageUrl
    },
    setLat (state, lat) {
      state.lat = lat
    },
    setLng (state, lng) {
      state.lng = lng
    },
    setFromSns (state, fromSns) {
      state.fromSns = fromSns
    }
  },
  actions: {
    setId ({ commit }, id) {
      commit('setId', id)
    },
    setName ({ commit }, name) {
      commit('setName', name)
    },
    setDescription ({ commit }, description) {
      commit('setDescription', description)
    },
    setImageUrl ({ commit }, imageUrl) {
      commit('setImageUrl', imageUrl)
    },
    setLat ({ commit }, lat) {
      commit('setLat', lat)
    },
    setLng ({ commit }, lng) {
      commit('setLng', lng)
    },
    setFromSns ({ commit }, fromSns) {
      commit('setFromSns', fromSns)
    }
  }
}

export default detail



// WEBPACK FOOTER //
// ./src/vuex/detail.js